// extracted by mini-css-extract-plugin
export default {"difficulty":"Settings_difficulty__4sJcA","easy":"Settings_easy__SF4pV","hard":"Settings_hard__qxs4S"};